var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"py-2"},[_c('router-link',{attrs:{"to":'/collection/' + _vm.id}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }